module.exports = __webpack_public_path__ + "static/media/steefBartman.9b850ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/steefBartman.jpg
// module id = 1696
// module chunks = 1